
export default {
  name: 'labels',
  components: {},
  props: ['respData'],
  data () {
    return {

    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {

  }
}


